<template>
    <div class="BoothAdvertising">
        <div class="AdvertisingtHeader">
            <div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item
                        ><span style="font-weight: 600; color: #303133 !important"
                            >运营推广管理</span
                        ></el-breadcrumb-item
                    >
                    <el-breadcrumb-item>展位广告</el-breadcrumb-item>
                </el-breadcrumb>
                <div>
                    <span>行业分类：</span>
                    <el-select
                        clearable
                        v-model="industry_id"
                        style="margin-top: 10px"
                        placeholder="请选择"
                        @change="selectChange"
                    >
                        <el-option
                            v-for="item in classifyOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="nav">
                <el-button class="btn-blue" style="margin-right: 10px" @click="sendData"
                    >发送</el-button
                >
                <router-link :to="{ name: 'operateDataBoothAdvertisingAdd' }"
                    ><el-button class="btn-blue">创建展位广告</el-button></router-link
                >
            </div>
        </div>
        <div class="StoreMarketTable">
            <el-table
                ref="multipleTable"
                border
                :data="tableData"
                class="tableClass"
                style="
                    height: calc(100vh - 370px);
                    width: 100%;
                    flex: 1;
                    margin-top: 20px;
                    border: 1px solid #eeeeee;
                    overflow-y: auto;
                "
                :cell-style="{ fontSize: '14px', color: '#343441' }"
                :header-cell-style="{
                    fontWeight: 'normal',
                    height: '60px',
                    color: '#13131B',
                    background: '#F2F3FA',
                }"
            >
                <el-table-column type="selection" label="全选" width="45"></el-table-column>
                <el-table-column label="展位广告名称" prop="name" align="center"></el-table-column>
                <el-table-column label="备注" prop="bz" align="center"></el-table-column>
                <el-table-column
                    label="行业分类"
                    prop="industry_name"
                    align="center"
                ></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" style="color: #1122d8" @click="copy(scope.row)">
                            复制
                        </el-button>
                        <el-button
                            type="text"
                            style="color: #1122d8"
                            @click="editData(scope.row.id)"
                        >
                            编辑
                        </el-button>

                        <el-button
                            type="text"
                            style="color: #67c23a"
                            @click="genOptimal(scope.row)"
                        >
                            {{
                                scope.row.taskInfo?.status === 1
                                    ? '重新生成最优展位'
                                    : '生成最优展位'
                            }}
                        </el-button>

                        <el-button
                            type="text"
                            style="color: #67c23a"
                            @click="downloadGenOptimal(scope.row)"
                            v-if="scope.row.taskInfo?.status === 1"
                            >下载最优展位</el-button
                        >

                        <el-button
                            type="text"
                            style="color: #eb6547"
                            @click="deleData(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pages-center"
                :current-page="adminPages.currentPageNum"
                :page-size="adminPages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="adminPages.total"
                @current-change="adminCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog
            title="生成最优展位配置"
            :visible.sync="genOptimalDialogVisible"
            width="450px"
            append-to-body
            custom-class="gen-optimal-dialog"
        >
            <el-form :model="genOptimalForm" label-width="100px" label-position="left">
                <el-form-item label="时间段选择">
                    <el-checkbox-group v-model="genOptimalForm.time_slot">
                        <el-checkbox :label="1">时间段1 (1-6)</el-checkbox>
                        <el-checkbox :label="2">时间段2 (7-12)</el-checkbox>
                        <el-checkbox :label="3">时间段3 (13-18)</el-checkbox>
                        <el-checkbox :label="4">时间段4 (19-0)</el-checkbox>
                    </el-checkbox-group>
                    <div style="font-size: 12px; color: red">
                        *不指定时间段无需选择（系统自动选择）
                    </div>
                </el-form-item>
                <el-form-item label="循环次数">
                    <el-input-number
                        v-model="genOptimalForm.loop"
                        :min="1"
                        :max="100000"
                        controls-position="right"
                        style="width: 100%"
                    ></el-input-number>
                    <div style="font-size: 12px; color: #909399; margin-top: 4px">
                        指定时间段（循环次数建议:10-100）<br>
                        不指定时间段（循环次数建议:10000-100000）
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="genOptimalDialogVisible = false">取 消</el-button>
                <el-button type="primary" class="btn-blue" @click="handleGenOptimal"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { copyBooth, sendBooth } from '@/utils/apis';
import { instance } from '../../../utils/http';

export default {
    name: 'BoothAdvertising',
    data() {
        return {
            tableData: [],
            classifyOptions: [],
            industry_id: '',
            adminPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            genNotifys: [],
            genLoop: undefined,
            genOptimalDialogVisible: false,
            genOptimalForm: {
                id: null,
                loop: 10,
                time_slot: [4],
            },
        };
    },
    activated() {
        this.getBoothList();
        this.getCategoryList();
    },
    // mounted() {
    //     this.getBoothList()
    //     this.getCategoryList()
    // },
    methods: {
        selectChange() {
            this.getBoothList();
        },
        getCategoryList() {
            this.$http.axiosGet(this.$api.categoryList, res => {
                if (res.code === 200) {
                    this.classifyOptions = res.data;
                } else {
                    this.$message.warning(res.msg);
                }
            });
        },
        async sendData() {
            let id = this.$refs.multipleTable.selection.map(item => item.id).join('#');
            if (id && id.length > 0) {
                const result = await this.$common.sendData(sendBooth, { id: id });
                result && this.getListData();
            } else {
                this.$message.error('请勾选需要发送的数据');
            }
        },
        getBoothList(loading = true) {
            let param = {
                page: this.adminPages.currentPageNum,
                paging: 1,
                pageSize: this.adminPages.eachPageNum,
            };
            this.industry_id ? (param.industry_id = this.industry_id) : '';
            this.$http.axiosGetByOption(this.$api.booth, param, { loading }, res => {
                if (res.code === 200) {
                    this.tableData = res.data.data;
                    this.adminPages.total = res.data.total;

                    const notifysBooths = this.tableData.filter(
                        item => item.taskInfo?.status === 0
                    );

                    const existIds = this.tableData.map(item => item.id);
                    const localBooths = this.genNotifys.filter(item => !existIds.includes(item.id)); // 分页情况，缓存之前数据

                    if (
                        notifysBooths.length > 0 ||
                        localBooths.length > 0 ||
                        this.genNotifys.length > 0
                    ) {
                        this.setNotify(
                            [...notifysBooths, ...localBooths].map(item => ({
                                id: item.id,
                                name: item.name,
                            }))
                        );

                        clearTimeout(this.genLoop);
                        this.genLoop = setTimeout(() => this.getBoothList(false), 1000 * 5);
                    }
                } else {
                    this.$message.warning(res.msg);
                }
            });
        },
        copy(item) {
            this.$confirm('是否复制该条数据', '提示消息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'btn-blue',
                type: 'warning',
            })
                .then(() => {
                    copyBooth({ id: item.id })
                        .then(res => {
                            if (res.code === 200) {
                                this.$message.success('复制成功');
                                this.adminPages.currentPageNum = 1;
                                this.getBoothList();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err);
                        });
                })
                .catch(() => {
                    this.$message.info('已取消复制');
                });
        },
        deleData(id) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    let param = {
                        id: id,
                    };
                    this.$http.axiosPost(this.$api.boothDelete, param, res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                                duration: 1000,
                                onClose: () => {
                                    this.getBoothList();
                                },
                            });
                        } else {
                            this.$message.warning(res.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                });
        },
        editData(id) {
            this.$router.push({
                path: '/admin/operatedata/boothadvertisingtwo',
                query: {
                    id: id,
                },
            });
        },
        adminCurrentChange(val) {
            this.adminPages.currentPageNum = val;
            this.getBoothList();
        },

        setNotify(notifys) {
            const ids = notifys.map(item => item.id); // 当前正在执行的ids
            const success = this.genNotifys.filter(item => !ids.includes(item.id)); // 不在执行ids中，已生成完毕

            // 已完成的数据，下载+取消弹框
            success.forEach(item => {
                const row = this.tableData.find(({ id }) => item.id === id);
                if (row) this.downloadGenOptimal(row);

                item.notify?.close?.();
            });

            // 将列表数据添加
            notifys.forEach(item => {
                // 弹框列表中不存在数据，则添加

                if (this.genNotifys.every(({ id }) => item.id !== id)) {
                    setTimeout(() => {
                        const notify = this.$notify({
                            type: 'success',
                            title: '提示',
                            message: `${item.name}正在生成最优展位广告，请稍等...`,
                            duration: 0,
                            showClose: false,
                        });

                        this.genNotifys.push({ notify: notify, id: item.id, name: item.name });
                    }, 100);
                }
            });

            // 清理弹框列表，将不在执行ids中的数据清理
            this.genNotifys = this.genNotifys.filter(item => ids.includes(item.id));
        },

        genOptimal(row) {
            this.genOptimalForm.id = row.id;
            this.genOptimalForm.loop = 10;
            this.genOptimalForm.time_slot = [];
            this.genOptimalDialogVisible = true;
        },

        handleGenOptimal() {
            const params = new FormData();
            params.append('id', this.genOptimalForm.id);
            params.append('loop', this.genOptimalForm.loop);
            this.genOptimalForm.time_slot.forEach(slot => {
                params.append('time_slot[]', slot);
            });

            instance
                .post('booth/bastBooth', params, {
                    loading: false,
                })
                .then(res => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);
                        this.genOptimalDialogVisible = false;
                        this.getBoothList();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.$message.error('生成失败');
                });
        },

        downloadGenOptimal(row) {
            console.log(row);

            if (!row.taskInfo?.file) {
                return this.$message.warning('文件丢失');
            }

            const unit = row.taskInfo.file.split('.').at(-1);
            this.downloadFile(row.taskInfo.file, `${row.name}.${unit}`);
        },

        downloadFile(src, name) {
            const link = document.createElement('a');
            link.href = src;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },

    deactivated() {
        this.genNotifys.map(item => item.notify?.close?.());
        this.genNotifys = [];

        clearTimeout(this.genLoop);
    },

    destroyed() {
        this.genNotifys.map(item => item.notify?.close?.());
        this.genNotifys = [];

        clearTimeout(this.genLoop);
    },
};
</script>

<style scoped lang="scss">
::v-deep .el-table--border::after,
.el-table--group::after,
.el-table::before {
    display: none;
}

.nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 54px;
    .el-breadcrumb {
        line-height: 40px;
    }
}
.tableClass {
    ::v-deep th {
        padding: 0 !important;
        height: 45px;
        line-height: 45px;
    }
    ::v-deep td {
        padding: 0 !important;
        height: 45px;
        line-height: 45px;
    }
}
::v-deep .el-pagination {
    display: flex;
    justify-content: center;
    margin: 30px 0;
}
.BoothAdvertising {
    padding: 30px;
    height: calc(100vh - 320px);
    .AdvertisingtHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-breadcrumb {
            line-height: 40px;
        }
    }
}
.gen-optimal-dialog {
    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #f0f0f0;
        padding: 20px 24px;
    }
    ::v-deep .el-dialog__title {
        font-weight: 600;
        color: #303133;
    }
    ::v-deep .el-dialog__body {
        padding: 30px 48px;
    }
    ::v-deep .el-form-item__label {
        font-weight: 500;
    }
    ::v-deep .el-checkbox-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    ::v-deep .el-checkbox {
        margin-right: 0;
    }
}
</style>
